import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getInterests, UpdateUser } from "../api/api";
import "../Interest/Interest.css";
import bgImage from "../../assets/images/brown-background.jpg";
import Swal from "sweetalert2";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";

const Interest = () => {
  const navigate = useNavigate();
  const [interests, setInterests] = useState([]);
  const [selectedInterest, setSelectedInterest] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchInterests = async () => {
      try {
        const response = await getInterests();
        if (response?.success) {
          setInterests(response.data);
        } else {
          // alert("Failed to fetch interests");
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: "Failed to fetch interests",
          });
        }
      } catch (error) {
        console.error("Error fetching interests:", error);
      }
    };
    fetchInterests();
  }, []);

  const handleSelectInterest = (id) => {
    setSelectedInterest((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((interest) => interest !== id)
        : [...prevSelected, id]
    );
  };

  const handleContinue = async () => {
    if (selectedInterest.length === 0) {
      // alert("Please select at least 1 interest.");
      Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least 1 interest.",
      });
      return;
    }

    setIsLoading(true);
    try {
      const userDatas = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userDatas);
      const _id = parsedUserData?.id || parsedUserData?._id;

      const values = {
        user_id: _id,
        interest_id: selectedInterest,
        profile_completion_status: "UpdateProfileDetails",
      };
      console.log("values123", values);
      const response = await UpdateUser(values);
      console.log("response1234", response);

      if (response?.success) {
        // alert(response.message);
        navigate("/UpdateProfileDetails");
      } else {
        // alert(response.message);
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: response.message,
        });
      }
    } catch (error) {
      // alert("Something went wrong");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
      });
      console.error("Error updating interests:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="Interestcontainer sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="interestheader">
          <h2>Select your interests to match with similar users.</h2>
        </div>
        <div className="interests-container">
          {interests.map((interest) => (
            <button
              key={interest.id}
              className={`interest-option ${selectedInterest.includes(interest.id) ? "selected" : ""
                }`}
              onClick={() => handleSelectInterest(interest.id)}
            >
              {interest.name}
            </button>
          ))}
        </div>
        <button
          className="continue-btn"
          onClick={handleContinue}
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Continue"}
        </button>
      </div>
    </div>
  );
};

export default Interest;
